import { render, staticRenderFns } from "./FileNameTimeDisplay.vue?vue&type=template&id=33b2f5d1&scoped=true"
import script from "./FileNameTimeDisplay.vue?vue&type=script&lang=ts"
export * from "./FileNameTimeDisplay.vue?vue&type=script&lang=ts"
import style0 from "./FileNameTimeDisplay.vue?vue&type=style&index=0&id=33b2f5d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b2f5d1",
  null
  
)

export default component.exports